import { Button, ButtonGroup, ErrorPage } from '@uhg-uicl/ui-core/dist';
import { BaseRoute } from 'constants/routes';

export default () => {
  return (
    <>
      <ErrorPage
        title="404 - Page Cannot Be Found"
        dataTestId="not-found-example"
        message="Oops! We couldn't find that page. You may have an incorrect URL. If this issue persists, please contact a system administrator."
        footer={() => (
          <>
            {/* @ts-ignore */}
            <ButtonGroup className="footer">
              <Button
                buttonType="emphasized"
                name="Go Back Home"
                onClick={() => {
                  window.location.href = `${BaseRoute}`;
                }}
                size="medium"
                type="button"
                dataTestId="go-back-home-btn"
              />
            </ButtonGroup>
          </>
        )}
      />
    </>
  );
};
